import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';
import { Box } from '@change-corgi/design-system-legacy/layout';

export const ErrorState: React.FC = () => {
	return (
		<Box py={24}>
			<InlineMessage size="large" variant="error">
				<Translate value="fe.errors.generic_try_again" />
			</InlineMessage>
		</Box>
	);
};
